// @core/api/endpoints/task/get_task_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskNumberingSchemeResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get numbering scheme
 * Returns a task numbering scheme by ID.
 */
export async function GetTaskNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<TaskNumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.get<TaskNumberingSchemeResponse>(requestPath, { ...requestOptions });
}
